var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 46,
    viewBox: "0 0 102 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3232 12.9859V32.9569L33.0515 35.4232V15.3528L29.642 13.3843V37.3917L25.4523 39.8108V10.9652L22.0428 8.99751V41.7785L20.0279 42.942L17.854 41.6874V4.25466L20.0279 3L22.0428 4.16356L25.4523 6.13126L29.642 8.55031L33.0515 10.5188L37.3232 12.9859Z",
    fill: "#647CFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3313 8.59836L6.92173 10.5661L2.73291 12.9843V32.957L6.92173 35.3752L10.3313 37.3437L14.4447 39.7189V6.22321L10.3313 8.59836ZM10.3313 32.6191L6.92173 30.6505V15.405L10.3313 13.4365V32.6191Z",
    fill: "#647CFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3311 13.4364L14.4445 11.0613V21.3851L10.3311 21.5946V13.4364Z",
    fill: "url(#paint0_linear_316_57)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.854 6.57932L22.0428 8.99753V17.7271H17.854V6.57932Z",
    fill: "url(#paint1_linear_316_57)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4536 10.9669L29.6424 13.3851V22.1155H25.4536V10.9669Z",
    fill: "url(#paint2_linear_316_57)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0508 15.3528L37.3232 17.819V26.5006H33.0508V15.3528Z",
    fill: "url(#paint3_linear_316_57)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.984 22.8C53.984 21.3707 54.2827 20.1013 54.88 18.992C55.4773 17.8827 56.2987 17.008 57.344 16.368C58.3893 15.728 59.6053 15.408 60.992 15.408C62.4 15.408 63.6267 15.728 64.672 16.368C65.7173 17.008 66.528 17.8827 67.104 18.992C67.68 20.1013 67.968 21.3707 67.968 22.8C67.968 24.2293 67.6693 25.4987 67.072 26.608C66.496 27.7173 65.6853 28.592 64.64 29.232C63.5947 29.872 62.3787 30.192 60.992 30.192C59.6053 30.192 58.3893 29.872 57.344 29.232C56.2987 28.592 55.4773 27.7173 54.88 26.608C54.2827 25.4987 53.984 24.2293 53.984 22.8ZM49.152 22.8C49.152 24.4853 49.44 26.0533 50.016 27.504C50.592 28.9333 51.4133 30.1813 52.48 31.248C53.5467 32.3147 54.7947 33.1467 56.224 33.744C57.6747 34.32 59.264 34.608 60.992 34.608C62.72 34.608 64.2987 34.32 65.728 33.744C67.1787 33.1467 68.4267 32.3147 69.472 31.248C70.5387 30.1813 71.36 28.9333 71.936 27.504C72.5333 26.0533 72.832 24.4853 72.832 22.8C72.832 21.0933 72.5333 19.536 71.936 18.128C71.36 16.6987 70.528 15.4613 69.44 14.416C68.3733 13.3707 67.1253 12.5707 65.696 12.016C64.2667 11.44 62.6987 11.152 60.992 11.152C59.3067 11.152 57.7387 11.44 56.288 12.016C54.8587 12.5707 53.6107 13.3707 52.544 14.416C51.4773 15.4613 50.6453 16.6987 50.048 18.128C49.4507 19.536 49.152 21.0933 49.152 22.8ZM81.2975 21.424L87.7935 31.92L94.2895 21.424L95.7295 34H100.498L97.1695 10.48L87.7935 24.944L78.4175 10.48L75.0895 34H79.8575L81.2975 21.424Z",
    fill: "#6B83FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_316_57",
    x1: 12.3874,
    y1: 19.6087,
    x2: 12.3874,
    y2: 8.93457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#647CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38468F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_316_57",
    x1: 19.9484,
    y1: 16.7979,
    x2: 19.9484,
    y2: 5.80002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#647CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38468F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_316_57",
    x1: 27.548,
    y1: 21.1864,
    x2: 27.548,
    y2: 10.1884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#647CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38468F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_316_57",
    x1: 35.1874,
    y1: 25.5714,
    x2: 35.1874,
    y2: 14.5735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#647CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38468F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b1fb8c4b.svg";
export { ForwardRef as ReactComponent };